// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"src-components-Header----Header-module---headerContainer---3avkD","header":"src-components-Header----Header-module---header---2gV_n","headerItem":"src-components-Header----Header-module---headerItem---qTjVf","menuActionContainer":"src-components-Header----Header-module---menuActionContainer---2naiA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.scss
// module id = 378
// module chunks = 114276838955818